import React from 'react';
import { Drawer } from 'antd';
import * as _ from 'lodash';
import { CloseOutlined } from '@ant-design/icons';
import FileBrowser from '../../FileBrowser';

const TemplateBrowserDrawer = (
  {
    open,
    onClose,
    onSelect,
		workingFolder,
		onFileDrop,
		permissions,
		templates,
		hasTemplates,
    onTemplateToggle,
    loadingTemplates
	}) => {
  return (
    <Drawer
      title="Select Document Template"
      placement="bottom"
      width="100%"
      height="100%"
      maskClosable={false}
      onClose={onClose}
      closeIcon={<CloseOutlined />}
      open={open}
      getContainer="#new-document-container"
      rootStyle={{ position: "absolute" }}
      styles={{body: {padding: '0px 10px'}}}
    >
      <FileBrowser 
        onSelect={onSelect}
        onFileDrop={onFileDrop}
        workingFolder={workingFolder}
        permissions={permissions}
        templates={templates}
        hasTemplates={hasTemplates}
        onTemplateToggle={onTemplateToggle}
        loadingTemplates={loadingTemplates}
      />
  </Drawer>
)};

export default TemplateBrowserDrawer;